import { render, staticRenderFns } from "./DataSourcesComponent.vue?vue&type=template&id=448bd37e&scoped=true"
import script from "./DataSourcesComponent.vue?vue&type=script&lang=js"
export * from "./DataSourcesComponent.vue?vue&type=script&lang=js"
import style0 from "./DataSourcesComponent.vue?vue&type=style&index=0&id=448bd37e&prod&lang=scss"
import style1 from "./DataSourcesComponent.vue?vue&type=style&index=1&id=448bd37e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448bd37e",
  null
  
)

export default component.exports